import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimeTrackingService } from '../../services/time-tracking.service';
import { DataService } from '@app/shared/common/auth/data.service';
import { ActiveTimer } from '../../models/time-tracking.models';

@Component({
    selector: 'vf-sidebar-timer-indicator',
    templateUrl: './sidebar-timer-indicator.component.html',
    styleUrls: ['./sidebar-timer-indicator.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarTimerIndicatorComponent implements OnInit, OnDestroy {

    activeTimer: ActiveTimer | null = null;
    elapsed = '00:00:00';
    isStopping = false;

    private subs = new Subscription();

    constructor(
        private ttService: TimeTrackingService,
        private dataService: DataService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.subs.add(
            this.ttService.activeTimer$.subscribe(timer => {
                this.activeTimer = timer;
                this.cdr.markForCheck();
            })
        );
        this.subs.add(
            this.ttService.elapsedSeconds$.subscribe(seconds => {
                this.elapsed = this.ttService.formatElapsed(seconds);
                this.cdr.markForCheck();
            })
        );
    }

    openTask(): void {
        if (!this.activeTimer) return;
        this.dataService.openEditTaskModal.next([{ id: this.activeTimer.taskId }, false, false]);
    }

    stopTimer(): void {
        if (this.isStopping) return;
        this.isStopping = true;
        this.ttService.stopTimer().subscribe({
            next: () => {
                this.dataService.timerStopped.next(this.activeTimer);
                this.isStopping = false;
                this.cdr.markForCheck();
            },
            error: () => {
                this.isStopping = false;
                this.cdr.markForCheck();
            }
        });
    }

    get taskNameDisplay(): string {
        if (!this.activeTimer) return '';
        const name = this.activeTimer.taskName || '';
        return name.length > 40 ? name.substring(0, 40) + '...' : name;
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
